import { NgModule } from "@angular/core";
import { ActionRichiesteModalComponent } from "./richieste-action.component";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModalModule, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ToastrModule } from "ngx-toastr";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { BlockUIModule } from "ng-block-ui";
import { QuillModule } from "ngx-quill";
import { DragulaModule } from "ng2-dragula";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { AngularMultiSelectModule } from "angular2-multiselect-dropdown";
import { TranslateModule } from "@ngx-translate/core";
import { SubmitterDetailModule } from "../submitter-detail/submitter-detail.module";
import { ApplicationDataModule } from "../applicant-data/applicant-data.module";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";

@NgModule({
    declarations: [
        ActionRichiesteModalComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        NgbModalModule,
        ToastrModule.forRoot({
            maxOpened : 10,
            preventDuplicates: true,
            timeOut: 10000,
            positionClass: 'toast-screen-center',
        }),
        CalendarModule.forRoot({
              provide: DateAdapter,
              useFactory: adapterFactory,
            }),
        BlockUIModule.forRoot(),
        QuillModule.forRoot(),
        DragulaModule.forRoot(),
        
        NgMultiSelectDropDownModule,
        AngularMultiSelectModule,
        TranslateModule,
        ApplicationDataModule,
        SubmitterDetailModule
    ],
    exports: [
        ActionRichiesteModalComponent
      ]
    })
export class RichiesteActionModule { }